import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/Config/apiConfig';
import { useParams } from 'react-router-dom';

const EmailTemplateInput = () => {
  const { templateId = '' } = useParams();
  const decodedId = templateId ? atob(templateId) : templateId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const route = 'emailTemplate';

  useEffect(() => {
    if (templateId) { setIsEditing(true); fetchDetails(); }
  }, [templateId]);

  const fetchDetails = async () => {
    try {
      const response = await axios.get(API_DOMAIN + API_ROUTES['emailTemplate'] + id + '/', { headers });
      setFormData(response.data);
    } catch (error) { console.error('Error fetching Email Template details:', error); }
  };

  const fields = [{"name":"name","label":"Name","type":"text"},{"name":"subject","label":"Subject","type":"text"},{"name":"body","label":"Body","type":"textarea"},{"name":"is_active","label":"Is Active","type":"checkbox"}];

  return (
    <div>
      <h1>{isEditing ? 'Edit Email Template' : 'Create Email Template'}</h1>
      <FormComponent fields={fields} initialFormData={formData} route={route} />
    </div>
  );
};

export default EmailTemplateInput;